var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1712_33668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 0H208.283V55.6366H264V0Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8332 150.815C50.265 150.098 48.6835 149.411 47.0821 148.758L0 195.772V202.573L51.8332 150.815Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6675 154.739C58.1923 153.933 56.7005 153.157 55.1888 152.41L0 207.519V214.32L59.6675 154.739Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0237 163.9C72.7279 162.945 71.4156 162.013 70.0833 161.104L0 231.085V237.817L74.0237 163.9Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5888 169.095C79.3595 168.053 78.1102 167.034 76.8378 166.039L0 242.766V249.567L80.5888 169.095Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5171 147.372C41.8493 146.751 40.1681 146.164 38.4671 145.613L0 184.025V190.826L43.5171 147.372Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1237 140.481C13.0671 140.232 10.9939 140.033 8.90743 139.887L0 148.781V155.582L15.1237 140.481Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 143.831L4.19622 139.641C2.80413 139.595 1.40539 139.568 0 139.568V143.831Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7552 174.683C85.6023 173.565 84.4262 172.473 83.2334 171.398L0 254.515V261.316L86.7552 174.686V174.683Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2405 142.126C23.3334 141.734 21.4097 141.386 19.4727 141.084L0 160.529V167.33L25.2405 142.126Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6728 144.455C32.8953 143.94 31.0979 143.466 29.2905 143.031L0 172.276V179.077L34.6728 144.455Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0997 159.135C65.6977 158.239 64.2723 157.37 62.8304 156.527L0 219.267V226.138L67.0997 159.135Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.036 244.196C122.727 242.265 122.375 240.351 121.976 238.453L96.3936 263.999H103.205L123.036 244.196Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.066 234.416C120.624 232.611 120.142 230.826 119.624 229.055L84.6289 263.999H91.4399L121.066 234.416Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.454 225.276C117.899 223.581 117.308 221.902 116.683 220.24L72.8604 264H79.6746L118.454 225.276Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.265 254.717C124.112 252.64 123.906 250.576 123.654 248.529L108.161 263.999H114.972L124.268 254.717H124.265Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.525 259.408L119.927 264H124.611C124.611 262.464 124.581 260.931 124.528 259.408H124.525Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.454 200.957C106.63 199.56 105.779 198.18 104.902 196.816L37.623 263.998H44.3177L107.454 200.953V200.957Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9422 187.067C96.9389 185.796 95.9122 184.545 94.859 183.314L14.0576 263.999H20.8952L97.9389 187.067H97.9422Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.925 193.844C102.005 192.501 101.061 191.177 100.088 189.873L25.8516 264.002H32.6659L102.925 193.844Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.6 208.592C110.846 207.079 110.062 205.586 109.248 204.113L49.2715 264.003H56.109L111.6 208.592Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.285 216.69C114.624 215.087 113.932 213.501 113.208 211.936L61.0693 263.999H67.9069L115.285 216.69Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5459 180.681C91.4661 179.483 90.3631 178.309 89.2368 177.154L2.26562 264H9.10318L92.5459 180.678V180.681Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4668 138.259V34.8684C22.4668 29.673 26.683 25.4629 31.8859 25.4629H229.627C234.83 25.4629 239.046 29.673 239.046 34.8684V48.537",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.327 193.978L169.839 50.7266H71.1299L118.139 198.772C120.787 207.116 114.551 215.626 105.786 215.626H199.455C210.715 215.626 218.729 204.694 215.323 193.978H215.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.139 198.772L71.1301 50.7266H63.9005L71.5753 74.8955L79.8248 100.872L111.052 199.217C112.175 202.757 109.531 206.366 105.81 206.366H96.6131C94.2176 206.366 92.0946 204.817 91.3703 202.534L59.0896 100.872H51.8301L84.5859 204.027C86.7787 210.935 93.1976 215.626 100.454 215.626H105.786C114.551 215.626 120.79 207.116 118.139 198.772Z",
    fill: "#F7F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6094 206.367H105.806C109.527 206.367 112.172 202.757 111.049 199.217L79.8212 100.873H59.0859L91.3666 202.535C92.0909 204.818 94.2106 206.367 96.6094 206.367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9004 50.7266L71.5752 74.8955L63.9004 50.7266Z",
    fill: "#6F7C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.623 56.3466L169.839 50.7266H63.9001L111.049 199.213C112.172 202.753 109.527 206.363 105.806 206.363H96.6094C94.214 206.363 92.0909 204.814 91.3666 202.531L59.0859 100.869",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7646 188.848L84.5855 204.027C86.7783 210.934 93.1972 215.625 100.453 215.625H199.455C210.715 215.625 218.728 204.693 215.323 193.978L185.242 99.2461",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8215 100.869H51.8301L67.7811 151.108",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1299 50.7266L118.139 198.772C120.787 207.116 114.551 215.626 105.786 215.626",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6025 67.7188H159.693",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.421 111.24H173.511",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76 118.598H178.671",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8818 74.8945H166.886",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2207 104.309H176.225",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.118 126.029H154.097",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.441 174.291H193.531",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.78 181.65H198.691",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14 189.082H174.119",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.085 97.5742H161.56",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0283 81.6562H147.599",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.468 142.881H176.225",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747 150.053H190.751",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.893 156.818H187.252",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3457 113.52H83.838",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.708 120.951H86.197",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0312 169.213H101.524",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3662 176.57H103.859",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7285 184.002H106.218",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0566 137.801H91.549",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3359 144.975H93.8249",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4824 151.734H95.9747",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7814 151.108C69.7383 157.272 65.1301 163.555 58.658 163.555H32.0387C26.7527 163.555 22.4668 167.835 22.4668 173.113V232.323C22.4668 237.518 26.683 241.729 31.8859 241.729H229.627C234.83 241.729 239.046 237.518 239.046 232.323V83.3916C239.046 78.1132 234.76 73.8335 229.474 73.8335L184.186 73.8434C180.013 73.8434 176.322 71.1462 175.059 67.175L171.62 56.3496",
    stroke: "#6F7C87",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1712_33668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperIcon);
export default __webpack_public_path__ + "static/media/paper-icon.dd8056cc.svg";
export { ForwardRef as ReactComponent };